__turbopack_context__.v({
  "alt": "_4YKX6W_alt",
  "caption": "_4YKX6W_caption",
  "figure": "_4YKX6W_figure",
});
